<div class="mainColumn">

	<div class="portalCard">

		<div class="theLogo">
			<a
				[routerLink]="['/auth/login']"
				title="Startseite"
			>
				<img
					[src]="logoSrc || 'assets/logo.png'"
					style="max-width: 100%; margin: 0 0 2em 0; mix-blend-mode: darken;"
				>
			</a>
		</div>

		<div class="aTitle">
			<span>
				@if( bDataConfirmNeeded && bUserTermsConfirmNeeded ) {
					Datenschutz & Nutzungsbedingungen
				}
				@else if( bDataConfirmNeeded ) {
					Datenschutzhinweise
				}
				@else if( bUserTermsConfirmNeeded ) {
					Nutzungsbedingungen
				}
			</span>
		</div>

		<div>
			@if( bDataConfirmNeeded && bUserTermsConfirmNeeded ) {
				Bitte bestätigen Sie vor der ersten Anmeldung die Datenschutzhinweise und die Nutzungsbedingungen.
			}
			@else if( bDataConfirmNeeded ) {
				Bitte bestätigen Sie vor der ersten Anmeldung die Datenschutzhinweise.
			}
			@else if( bUserTermsConfirmNeeded ) {
				Bitte bestätigen Sie vor der ersten Anmeldung die Nutzungsbedingungen.
			}
		</div>

		<div class="colTerms">

			@if( bDataConfirmNeeded ) {
				<div class="subCol">
	
					<button
						mat-raised-button
						(click)="bUnfoldedDataProtection = !bUnfoldedDataProtection"
					>
						{{ bUnfoldedDataProtection ? 'Datenschutzerklärung einklappen' : 'Datenschutzerklärung anzeigen' }}
					</button>
	
					@if( bUnfoldedDataProtection ) {
	
						<div class="textContainer">

							@if( bLoading ) {
								<mat-spinner />
							}
							@else if( bError ) {
								<div class="errorWarning">
									Beim Laden der Daten ist ein Fehler aufgetreten
								</div>
							}
							@else {
								<div [innerHTML]="privacyPolicyHtml"></div>
							}
		
						</div>
	
					}
	
					<mat-checkbox (change)="confirmDataProtection()">
						Ich akzeptiere die Datenschutzrichtlinien dieser Website
					</mat-checkbox>
	
				</div>
			}

			@if( bUserTermsConfirmNeeded ) {
				<div class="subCol">
	
					<button
						mat-raised-button
						(click)="bUnfoldedTerms = !bUnfoldedTerms"
					>
						{{ bUnfoldedTerms ? 'Nutzungsbedingungen einklappen' : 'Nutzungsbedingungen anzeigen' }}
					</button>
	
					@if( bUnfoldedTerms ) {
	
						<div class="textContainer">

							@if( bLoading ) {
								<mat-spinner />
							}
							@else if( bError ) {
								<div class="errorWarning">
									Beim Laden der Daten ist ein Fehler aufgetreten
								</div>
							}
							@else {
								<div [innerHTML]="termsOfUseHtml"></div>
							}

						</div>

					}
	
					<mat-checkbox (change)="confirmTermsOfUse()">
						Ich akzeptiere die Nutzungsbedingungendieser Website
					</mat-checkbox>
	
				</div>
			}

			<button
				[disabled]="(bDataConfirmNeeded && !isDataConfirmed) || (bUserTermsConfirmNeeded && !isTermsConfirmed)"
				mat-flat-button
				(click)="confirm()"
			>
				Akzeptieren
			</button>

		</div>

		<mat-progress-bar *ngIf="bInProgress" mode="indeterminate"></mat-progress-bar>

	</div>

	<footer-login />

</div>